const MULTI_WORD_TYPES = new Set(['chunk', 'phrase', 'idiom', 'phrasal_verb']);
const MAX_WORDS_MULTI = 6;
const MAX_WORDS_ANY = 8;
const DIGIT_PATTERN = /\d/;
const TIME_PATTERN = /\bo'clock\b/i;

export function isBadExtraction(content: string, type: string): string | null {
  const wordCount = content.trim().split(/\s+/).length;
  if (MULTI_WORD_TYPES.has(type) && wordCount > MAX_WORDS_MULTI) {
    return `${type} too long (${wordCount} words)`;
  }
  if (wordCount > MAX_WORDS_ANY) {
    return `too long (${wordCount} words)`;
  }
  if (DIGIT_PATTERN.test(content)) {
    return 'contains digits';
  }
  if (TIME_PATTERN.test(content)) {
    return 'contains time pattern';
  }
  return null;
}
